import { render } from "./OrganizationalChartSectionOther.vue?vue&type=template&id=e4b1456c&scoped=true"
import script from "./OrganizationalChartSectionOther.vue?vue&type=script&lang=js"
export * from "./OrganizationalChartSectionOther.vue?vue&type=script&lang=js"

import "./OrganizationalChartSectionOther.vue?vue&type=style&index=0&id=e4b1456c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b1456c"]])

export default __exports__